import React, { useCallback } from "react";
import { useForm } from "antd/es/form/Form";
import { Button, Col, Row } from "antd";
import { observer } from "mobx-react";
import { History } from "history";
import config from "./config";
import Form from "../../common/forms/form";
import Field from "../../common/forms/field";
import ResetPassword from "../../../stores/ResetPassword";
import { LOGIN_PATH } from "../../../constants/auth";
import { CANCEL_BUTTON, RESET_BUTTON } from "../../../constants/buttons";

interface Props {
  token: string;
  email: string;
  history: History;
}

const store = new ResetPassword();

const gutter = 15;

const RestorePassword: React.FC<Props> = ({ token, email, history }) => {
  const [form] = useForm();

  const onFinishHandler = useCallback(
    (values: unknown): void => {
      const parameters = {
        ...(values as object),
        email,
        token,
      };

      store.resetPassword(parameters).finally(() => {
        if (Object.keys(store.errors).length > 0) {
          return;
        }

        form.resetFields();
      });
    },
    [email, form, token]
  );

  const onCancelHandler = useCallback(() => {
    form.resetFields();
    history.push(LOGIN_PATH);
  }, [form, history]);

  return (
    <Form
      config={config}
      errors={store.errors as { [key: string]: string[] | null }}
      onFinishHandler={onFinishHandler}
      form={form}
    >
      <Field name="password" />
      <Field name="password_confirmation" />

      <Row gutter={gutter}>
        <Col>
          <Button type="primary" htmlType="submit">
            {RESET_BUTTON}
          </Button>
        </Col>
        <Col>
          <Button type="default" htmlType="button" onClick={onCancelHandler}>
            {CANCEL_BUTTON}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default observer(RestorePassword);
